<div class="loading-overlay" [class.visible]="cargando">
  <div class="loading-spinner"></div>
</div>

<router-outlet></router-outlet>
<button *ngIf="mostrarBoton" class="scroll-bottom-btn" (click)="irAlFinal()" >
    <mat-icon class="icon-arrow">arrow_back</mat-icon>
</button>